import * as moment from "moment";
import { DatexPipe } from "../pipes/datex/datex";
import { Participant } from "./participant";

export class ChatGroupAdmin {
    id: number;
    participant_id: number;
    chat_group_id: number;
    role: string = 'moderator';
    participant: Participant;

    /**
     * constructor
     *
     * @param {ChatGroupAdmin} init
     */
    public constructor(init?: ChatGroupAdmin) {
        if (!!init) {
            Object.assign(this, init);

            if (init.participant) {
                this.participant = new Participant(init.participant);
            }
        }
    }
}
